export default "__VITE_ASSET__D6IcAo5Y__"